// extracted by mini-css-extract-plugin
export default {"container":"AdminTopMenu_container__ZTEDU","manaberlogoCopy1":"AdminTopMenu_manaberlogoCopy1__WmBe9","separator":"AdminTopMenu_separator__Y77He"};